import React from 'react';
import Carousel from './resuable-components/Carousel';

import EconomicTimes from './assets/economictimes.webp';
import FinancialExpress from './assets/financialexpress.webp';

const testimonials = [
  {
    image: EconomicTimes,
    title: 'Economic Times',
    quote:
      'EximPe secured $3.5 million seed funding led by Leo Capital to hire talent, strengthen its product, and rapidly scale cross-border payments.',
    readMoreUrl:
      'https://economictimes.indiatimes.com/tech/funding/eximpe-raises-3-5-million-in-funding-led-by-leo-capital/articleshow/90785474.cms',
  },
  {
    image: FinancialExpress,
    title: 'Financial Express',
    quote:
      "EximPe simplifies cross-border trade with a fully paperless digital platform, enabling seamless payments and competitive foreign-exchange rates.",
    readMoreUrl:
      'https://www.financialexpress.com/business/sme-eximpe-making-cross-border-trade-seamless-2528471/',
  },
  {
    image: EconomicTimes,
    title: 'Economic Times',
    quote:
      "Novice exporters should adopt platforms like EximPe for payments, documentation, compliance and leverage Amazon Global Selling for market access.",
    readMoreUrl:
      'https://economictimes.indiatimes.com/small-biz/trade/exports/process/how-novice-exporters-can-tackle-problems-using-best-tech-practices/articleshow/92222259.cms',
  },
  {
    image: EconomicTimes,
    title: 'Economic Times',
    quote:
      "Exporters face volatile forex risks; solutions include hedging, letters of credit, digital rate platforms like EximPe, and blockchain-based document transfers.",
    readMoreUrl:
      'https://economictimes.indiatimes.com/small-biz/trade/exports/process/how-to-step-up-handling-of-forex-related-issues-faced-by-exporters/articleshow/91881950.cms',
  },
];

const TestimonialSection: React.FC = () => (
    <div className="text-[#1A202C] max-w-6xl mx-auto px-4 sm:px-8">
      <h2 className="text-center text-4xl font-bold text-gray-900 mb-12">
        We Are In News
      </h2>

      <Carousel
        items={testimonials}
        renderItem={(t, isCenter) => (
          <div
            className={`
              relative 
              bg-white/90          /* subtle white overlay */
              rounded-2xl 
              p-12 pt-20 
              text-center 
              shadow-lg 
              w-80 h-96        
              flex-shrink-0    
            `}
          >
            <div className="absolute left-1/2 -translate-x-1/2 top-1">
              <img
                src={t.image}
                alt={t.title}
                className="w-16 h-16 rounded-full border-4 border-white shadow-md object-cover"
              />
            </div>

            <h4
              className={`mt-4 text-lg font-semibold ${
                isCenter ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              {t.title}
            </h4>

            <blockquote className="italic text-gray-700 leading-relaxed overflow-auto h-40">
              “{t.quote}”
            </blockquote>

            {t.readMoreUrl && (
              <a
                href={t.readMoreUrl}
                className="mt-4 inline-block text-[#27a887] hover:underline"
              >
                Continue reading…
              </a>
            )}
          </div>
        )}
      />
    </div>
 
);

export default TestimonialSection;
